/** Lifecycle state of a referral partner's access. */
export enum PartnerStatusEnum {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  ENDED = "ENDED",
  ENDED_FOR_CAUSE = "ENDED_FOR_CAUSE",
}

/** An admin action that moves a partner between statuses. */
export enum PartnerStatusActionEnum {
  SUSPEND = "SUSPEND",
  RESTORE = "RESTORE",
  END = "END",
  END_FOR_CAUSE = "END_FOR_CAUSE",
}

/** How a partner's negative balance is settled when their access ends. */
export enum NegativeBalanceResolutionEnum {
  RECOVERED = "RECOVERED",
  WRITTEN_OFF = "WRITTEN_OFF",
}

/** Lifecycle state of a referral. */
export enum ReferralStatusEnum {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ENDED = "ENDED",
  REVOKED = "REVOKED",
}

/** Whether an invite is a plain referral or one that grants a Pro trial. */
export enum ReferralInviteKindEnum {
  PLAIN = "PLAIN",
  PRO_TRIAL = "PRO_TRIAL",
}

/** How a referral came to exist. */
export enum ReferralOriginEnum {
  INVITE = "INVITE",
}

/** Per-address result of sending a partner invite. */
export enum InviteOutcomeEnum {
  INVITED = "INVITED",
  RESENT = "RESENT",
  NOT_REFERABLE = "NOT_REFERABLE",
  DAILY_CAP_REACHED = "DAILY_CAP_REACHED",
  PRO_TRIAL_DISABLED = "PRO_TRIAL_DISABLED",
  PARTNER_SUSPENDED = "PARTNER_SUSPENDED",
}

/** The kind of referred-customer payment a commission is earned on. */
export enum ReferredPaymentKindEnum {
  SUBSCRIPTION = "SUBSCRIPTION",
  TOKEN_PURCHASE = "TOKEN_PURCHASE",
  ORGANIZATION_CHARGE = "ORGANIZATION_CHARGE",
}

/** What produced a commission ledger entry. */
export enum CommissionSourceKindEnum {
  PAYMENT = "PAYMENT",
  REFUND = "REFUND",
  CHARGEBACK = "CHARGEBACK",
  CHARGEBACK_REVERSAL = "CHARGEBACK_REVERSAL",
  REVOCATION_REVERSAL = "REVOCATION_REVERSAL",
  BALANCE_RESOLUTION = "BALANCE_RESOLUTION",
}

/** Review and payout state of a monthly commission statement. */
export enum StatementStatusEnum {
  OPEN = "OPEN",
  HELD_FOR_REVIEW = "HELD_FOR_REVIEW",
  APPROVED = "APPROVED",
  PAID = "PAID",
}

/** An entry in a referral's audit history. */
export enum ReferralHistoryActionEnum {
  CREATED = "CREATED",
  RESENT = "RESENT",
  ACTIVATED = "ACTIVATED",
  EXPIRED = "EXPIRED",
  ENDED = "ENDED",
  READDRESSED = "READDRESSED",
  REVOKED = "REVOKED",
}

/** The admin step that moves a statement to its next status. */
export enum StatementReviewActionEnum {
  RELEASE = "RELEASE",
  APPROVE = "APPROVE",
  RECORD_PAYOUT = "RECORD_PAYOUT",
}

/** Error `code` values the partner and partner-admin endpoints return. */
export enum PartnerApiErrorCodeEnum {
  AGREEMENT_NOT_ACCEPTED = "AGREEMENT_NOT_ACCEPTED",
  PARTNER_NOT_FOUND = "PARTNER_NOT_FOUND",
  NEGATIVE_BALANCE_RESOLUTION_REQUIRED = "NEGATIVE_BALANCE_RESOLUTION_REQUIRED",
}
